import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { SectionHeading } from './SectionHeading';
const stack = [{
  emoji: '📘',
  title: 'COMPLEX REHAB CASE AUDIT™',
  text: '6 Professional Audit Volumes',
  value: '$97'
}, {
  emoji: '🎁',
  title: '5 PROFESSIONAL BONUSES',
  text: 'Red Flags, VDO Master Map, Case Challenges, Quick Cards, Final Case Readiness Check',
  value: '$197'
}, {
  emoji: '📋',
  title: '30+ CLINICAL AUDIT TOOLS',
  text: 'Protocols, checklists, maps, matrices, worksheets and quick references',
  value: '$97'
}];
const included = ['Instant digital access', 'Lifetime access', 'No monthly subscription', '6 Professional Audit Volumes', '5 Exclusive Bonuses', '30+ Clinical Tools', '7-Day Guarantee'];
export function Offer() {
  return <section id="offer" className="bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-222" data-mp="2affse55meeyo">
      <div className="mx-auto w-full max-w-3xl" data-id="element-223" data-mp="pml7vloyzhcs">
        <SectionHeading tone="light" eyebrow="🏆 The complete Dr. Karito Case Audit system" title="Here’s everything you get today" data-id="element-224" data-mp="ui8zs8uu6olz" />

        <div className="mt-10 space-y-3" data-id="element-225" data-mp="13jqebmslii8k">
          {stack.map(s => <div key={s.title} className="flex items-start gap-4 rounded-2xl bg-white/[0.05] p-4 ring-1 ring-white/10 sm:p-5" data-id="element-226" data-mp="13hnlyw3z0d0o">
              <span className="text-2xl" aria-hidden="true" data-id="element-227" data-mp="btc1ltwbjbyh">
                {s.emoji}
              </span>
              <div className="min-w-0 flex-1" data-id="element-228" data-mp="ft4e2hou2294">
                <h3 className="text-[13px] font-extrabold uppercase leading-snug tracking-[0.06em] text-cream-50 sm:text-sm" data-id="element-229" data-mp="klnt7j3655g1">
                  {s.title}
                </h3>
                <p className="mt-1 text-[13px] leading-snug text-cream-100/70 sm:text-sm" data-id="element-230" data-mp="3k6t1q00jil4l">
                  {s.text}
                </p>
              </div>
              <span className="shrink-0 font-display text-base font-bold text-gold-400 sm:text-lg" data-id="element-231" data-mp="vefrbwq0fuyg">
                {s.value}
              </span>
            </div>)}
        </div>

        <div className="mt-6 flex items-center justify-between rounded-2xl border border-dashed border-gold-500/40 px-5 py-4" data-id="element-232" data-mp="154ikbwx4t8ws">
          <span className="text-xs font-extrabold uppercase tracking-[0.14em] text-cream-100/70" data-id="element-233" data-mp="1078w2klhb3aj">
            Total value
          </span>
          <span className="font-display text-2xl font-bold text-cream-100/60 line-through" data-id="element-234" data-mp="7i1pcybvf7e7">
            $391
          </span>
        </div>

        <div className="mt-6 rounded-3xl bg-white p-6 text-center sm:p-8" data-id="element-235" data-mp="licg81d6klzd">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-clay" data-id="element-236" data-mp="hfpv0jb0lzb5">
            Today you get everything for just
          </p>
          <p className="mt-2 font-display text-6xl font-bold leading-none text-navy-900 sm:text-7xl" data-id="element-237" data-mp="1wyszy6vrpos1">
            $27
          </p>
          <p className="mt-2 text-xs font-bold uppercase tracking-[0.16em] text-navy-700/60" data-id="element-238" data-mp="20exbiav529ys">
            One-time payment
          </p>

          <ul className="mt-6 grid gap-2 text-left sm:grid-cols-2" data-id="element-239" data-mp="25eib8ni4umck">
            {included.map(i => <li key={i} className="flex items-center gap-2.5" data-id="element-240" data-mp="1qi0zhv6175ph">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-navy-900" data-id="element-241" data-mp="1verd8bud5p7q">
                  <CheckIcon className="h-3 w-3 text-gold-400" aria-hidden="true" data-id="element-242" data-mp="2j66kmj0zywpu" />
                </span>
                <span className="text-[14px] font-medium text-navy-900" data-id="element-243" data-mp="29fbzjhzhm35z">
                  {i}
                </span>
              </li>)}
          </ul>

          <p className="mt-5 flex items-center justify-center gap-2 rounded-xl bg-cream-100 px-4 py-3 text-[12px] font-semibold leading-snug text-navy-700/85 sm:text-[13px]" data-id="element-244" data-mp="2eclvzhlanf3b">
            <GlobeIcon className="h-4 w-4 shrink-0 text-navy-900" aria-hidden="true" data-id="element-245" data-mp="36vhowahk398q" />
            Currency conversion is automatic — pay in your local currency at
            checkout.
          </p>

          <div className="mt-6 flex flex-col items-center gap-6" data-id="element-246" data-mp="1e9o229muqjhm">
            <CTAButton label="Get the Complex Rehab Case Audit™" subLabel="One payment of $27 · Instant access · Lifetime reference" data-id="element-247" data-mp="198qknz9o1th6" />
            <Countdown tone="dark" data-id="element-248" data-mp="21x5mtl7p8hb3" />
            <ScarcityBar tone="dark" data-id="element-249" data-mp="21w48n7vdzep5" />
          </div>
        </div>
      </div>
    </section>;
}